import { ClipboardIcon, OpenInNewWindowIcon } from '@radix-ui/react-icons'
import { Provider } from '@radix-ui/react-tooltip'
import { Tooltip } from '@radix-ui/themes'
import React, { MouseEvent } from 'react'
import styled from 'styled-components'

const StyledContainer = styled.div`
  width: 100%;
  display: flex;
  font-weight: 600;
  font-size: 0.875rem;
  line-height: 1.1875rem;
  padding: 0.5rem 1rem;
  justify-content: space-between;
  align-items: center;
`

const StyledSupportButton = styled.div`
  a {
    color: ${({ theme }) => theme.forecast.text4};
  }
  a:hover {
    color: ${({ theme }) => theme.forecast.text1};
  }
  height: 100%;
`

const StyledLink = styled.a`
  text-decoration: inherit;
  display: flex;
  align-items: center;
`

const StyledSubText = styled.div`
  color: ${({ theme }) => theme.forecast.text4};
  font-size: 11px;
`

export const StyledOpenInNewWindowIcon = styled(OpenInNewWindowIcon)`
  margin-left: 5px;
`

const supportEmailAddress: string = 'support@geckorobotics.com'

export const EmailSupport: React.FC = () => {
  const copyAddress = (event: MouseEvent) => {
    navigator.clipboard.writeText(supportEmailAddress)
    event.stopPropagation()
  }

  return (
    <StyledContainer>
      <StyledSupportButton>
        <StyledLink href={`mailto:${supportEmailAddress}`}>
          Email Support
          <StyledOpenInNewWindowIcon />
        </StyledLink>
        <StyledSubText onClick={copyAddress}>
          {supportEmailAddress}
        </StyledSubText>
      </StyledSupportButton>
      <Provider>
        <Tooltip
          content={'Copy Email Address'}
          side={'left'}
          style={{ minHeight: 'auto' }}>
          <span aria-label={'Copy to Clipboard'}>
            <ClipboardIcon onClick={copyAddress} />
          </span>
        </Tooltip>
      </Provider>
    </StyledContainer>
  )
}
